import { useAtom } from "jotai";
import { currentUserAtom } from "lib/atoms/auth";

const nurseClinicManagerIds = [
  "651287d9a72e6613a58a35f5", // Aleksandra Lasok
  "630c4cad9468b43b9c6dd938", // Anna Olchówka
];

const doctorClinicManagerIds: string[] = [];

const doctorMedicalManagersIds = [
  "660670d65a3c70eac6081608", // Konrad Michalski
  "62e3a7dd863417553b14e20d", // Piotr Gibas
  "609a94b4736cccde3ee41ed4", // Kasia Błońska-Frączek
  "635697756a9061357353cfc8", // Ewa Miklińska-Lipka
];

export const useUserGenre = () => {
  const [currentUser] = useAtom(currentUserAtom);

  if (!currentUser) {
    return {
      isNurse: false,
      isAssistant: false,
      isDoctor: false,
      isStaff: false,
      isClinicManager: false,
      isNurseClinicManager: false,
      isDoctorClinicManager: false,
      isPureClinicManager: false,
      isHybridClinicManager: false,
    };
  }

  const { id, genre } = currentUser;

  const isNurse = genre === "NURSE";
  const isAssistant = genre === "ASSISTANT";
  const isDoctor = genre === "DOCTOR";
  const isStaff = genre === "STAFF";
  const isPureClinicManager = genre === "CLINIC_MANAGER";
  const isNurseClinicManager = nurseClinicManagerIds.includes(id);
  const isDoctorClinicManager = doctorClinicManagerIds.includes(id);
  const isHybridClinicManager = isNurseClinicManager || isDoctorClinicManager;
  const isDoctorMedicalManager = doctorMedicalManagersIds.includes(id);
  const isMedicalManager = isDoctorMedicalManager;

  const isClinicManager =
    isPureClinicManager || isNurseClinicManager || isDoctorClinicManager;

  return {
    isNurse,
    isAssistant,
    isDoctor,
    isStaff,
    isClinicManager,
    isMedicalManager,
    isDoctorMedicalManager,
    isPureClinicManager,
    isHybridClinicManager,
  };
};
